import { render, staticRenderFns } from "./Formulary.vue?vue&type=template&id=6e8b3e56&"
import script from "./Formulary.vue?vue&type=script&lang=js&"
export * from "./Formulary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports